import { useQueryClient } from '@tanstack/react-query';
import { useMutation } from 'query';
import { getProfileQueryKey } from 'features/users';
import { unSync } from '../services';

export const useDesyncAccount = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, unknown>({
    async mutationFn() {
      await unSync();
    },
    async onSuccess() {
      await queryClient.invalidateQueries({ queryKey: getProfileQueryKey() });
    },
  });
};
